module.exports = __webpack_public_path__ + "01d9cb9eb51bc4f6db63df0df8365b71.svg";